import { render, staticRenderFns } from "./InventoryTable.vue?vue&type=template&id=8b61a294&scoped=true&"
import script from "./InventoryTable.vue?vue&type=script&lang=js&"
export * from "./InventoryTable.vue?vue&type=script&lang=js&"
import style0 from "./InventoryTable.vue?vue&type=style&index=0&id=8b61a294&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b61a294",
  null
  
)

export default component.exports